var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import styles from '../../@patternfly/patternfly-next/components/FormControl/form-control.css.js';
import { css } from '@patternfly/react-styles';
import PropTypes from 'prop-types';

var propTypes = {
  /** Additional classes added to the TextArea. */
  className: PropTypes.string,
  /** Flag to show if the TextArea is required. */
  isRequired: PropTypes.bool,
  /** Flag to show if the TextArea is valid or invalid. */
  isValid: PropTypes.bool,
  /** Value of the TextArea. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** A callback for when the TextArea value changes. */
  onChange: PropTypes.func,
  /** Custom flag to show that the TextArea requires an associated id or aria-label. */
  'aria-label': function ariaLabel(props) {
    if (!props.id && !props['aria-label']) {
      return new Error('TextArea requires either an id or aria-label to be specified');
    }
    return null;
  }
};

var defaultProps = {
  className: '',
  isRequired: false,
  isValid: true,
  value: null,
  onChange: function onChange() {
    return undefined;
  },
  'aria-label': null
};

var TextArea = function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
      _this.props.onChange(event.currentTarget.value, event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextArea, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          value = _props.value,
          onChange = _props.onChange,
          isValid = _props.isValid,
          isRequired = _props.isRequired,
          props = _objectWithoutProperties(_props, ['className', 'value', 'onChange', 'isValid', 'isRequired']);

      return React.createElement('textarea', _extends({}, props, {
        className: css(styles.formControl, className),
        onChange: this.handleChange,
        value: value,
        'aria-invalid': !isValid,
        required: isRequired
      }));
    }
  }]);

  return TextArea;
}(React.Component);

TextArea.propTypes = propTypes;
TextArea.defaultProps = defaultProps;

export default TextArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/TextArea/TextArea.js
// module id = 283
// module chunks = 0